import React, { useEffect } from 'react'
import './Contato.scss'
import * as typeformEmbed from '@typeform/embed'

const Typeform = () => {
  useEffect(() => {
    const embedElement = document.querySelector('.js-typeform-embed')
    console.log(embedElement);

    typeformEmbed.makeWidget(
      embedElement,
      'https://form.typeform.com/to/y3f3sOXx',
      {
        opacity: 0,
        buttonText: "Começar!",
        hideScrollbars: true,
      }
    )
  }, []);

  return (
    <section className="section-contact" style={{marginBottom: '150px'}}>
      <div className="container form typeform">
        <div className="grid-1">
          <div className="col">
            <div className="js-typeform-embed">Typeform</div>
          </div>
        </div>
      </div>
    </section>
  );
}

const Pipefy = (props, context) =>
<section className="section-contact" style={{marginBottom: '150px'}}>
  <div className="container form pipefy">
    <div className="grid-1">
      <div className="col">
        <iframe width="560" height="2000" title="pipefy" src="//app.pipefy.com/public/form/qMAM8cUG?embedded=true" frameBorder="0" />
      </div>
    </div>
  </div>
</section>

export {
  Typeform,
  Pipefy,
};



// WEBPACK FOOTER //
// ./src/components/Contato/forms.js